import React, { useState, useEffect } from 'react';
import MainLayout from '../../layouts/main/MainLayout';
import MappingModal from '../../components/MappingModal/MappingModal';
import * as S from './Mapping.style';

const Mapping = () => {
  const [existingVariables, setExistingVariables] = useState([
    { id: 1, name: 'I. 병원 현황->병원명' },
    { id: 2, name: 'I. 병원 현황->소재지' },
    { id: 3, name: 'I. 병원 현황->병원형태->설립주체' },
    { id: 4, name: 'I. 병원 현황->병원명' },
    { id: 5, name: 'I. 병원 현황->소재지' }
  ]);

  const [newVariables, setNewVariables] = useState([
    { id: 1, name: 'I. 병원 현황->병원명' },
    { id: 2, name: 'I. 병원 현황->소재지' },
    { id: 3, name: 'I. 병원 현황->병원형태->설립 주최' },
    { id: 4, name: 'I. 병원 현황->병원명' },
    { id: 5, name: 'I. 병원 현황->소재지' }
  ]);

  const [mappingResults, setMappingResults] = useState([
    { id: 1, existingVariableId: 1, newVariableId: 1, status: 'matched' },
    { id: 2, existingVariableId: 2, newVariableId: 2, status: 'similar' },
    { id: 3, existingVariableId: 3, newVariableId: 3, status: 'error' },
    { id: 4, existingVariableId: 4, newVariableId: 4, status: 'matched' },
    { id: 5, existingVariableId: 5, newVariableId: 5, status: 'pending' }
  ]);

  // 필터 상태 추가
  const [isLocked, setIsLocked] = useState(false);
  const [showMatched, setShowMatched] = useState(true);
  const [showSimilar, setShowSimilar] = useState(true);
  const [showUnclassified, setShowUnclassified] = useState(true);

  useEffect(() => {
    // Initialize component
    return () => {};
  }, []);

  const handleVariableMap = (existingVar, newVar) => {
    console.log('[MAPPING]', 'Variable mapped:', existingVar, '->', newVar);
    
    const newMapping = {
      id: Date.now(),
      existingVariableId: existingVar.id,
      newVariableId: newVar.id,
      status: 'matched'
    };
    
    setMappingResults(prev => [
      ...prev.filter(m => m.newVariableId !== newVar.id),
      newMapping
    ]);
  };

  const handleVariableUnmap = (mappingId) => {
    console.log('[MAPPING]', 'Variable unmapped:', mappingId);
    setMappingResults(prev => prev.filter(m => m.id !== mappingId));
  };

  const handleToggleLock = () => {
    setIsLocked(prev => !prev);
    console.log('[MAPPING]', 'Lock toggled:', !isLocked);
  };

  const handleFilterToggle = (filterType) => {
    console.log('[MAPPING]', 'Filter toggled:', filterType);
    
    switch (filterType) {
      case 'matched':
        setShowMatched(prev => !prev);
        break;
      case 'similar':
        setShowSimilar(prev => !prev);
        break;
      case 'unclassified':
        setShowUnclassified(prev => !prev);
        break;
      default:
        break;
    }
  };

  return (
    <MainLayout>
      <S.ContentSection>
        <MappingModal
          existingVariables={existingVariables}
          newVariables={newVariables}
          mappingResults={mappingResults}
          isLocked={isLocked}
          showMatched={showMatched}
          showSimilar={showSimilar}
          showUnclassified={showUnclassified}
          onVariableMap={handleVariableMap}
          onVariableUnmap={handleVariableUnmap}
          onToggleLock={handleToggleLock}
          onFilterToggle={handleFilterToggle}
        />
      </S.ContentSection>
    </MainLayout>
  );
};

export default Mapping;